import React from 'react';
import { Flex, Text, Button, HStack } from '@chakra-ui/react';
import analytics from '../../../../../segmentTracking';

const PaginationControls = ({
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange,
  entityName = 'items',
  analyticsPrefix = 'academic',
  loading = false,
  showPagination = true,
}) => {
  const [currentUser] = React.useState(
    JSON.parse(localStorage.getItem('user')),
  );

  // Pagination calculations
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (page) => {
    onPageChange(page);
    analytics.track(`settings:${analyticsPrefix}:pagechanged`, {
      page,
      totalPages,
      entityName: entityName,
      userRole: currentUser?.role,
      email: currentUser?.email,
    });
  };

  // Generate page numbers for pagination
  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  if (!showPagination || totalPages <= 1) {
    return null;
  }

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      mt={6}
      pt={4}
      borderTop="1px solid #E7E7E7"
    >
      <Text fontSize="14px" color="#757575">
        Showing {(currentPage - 1) * itemsPerPage + 1} to{' '}
        {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems}{' '}
        {entityName}
      </Text>

      <HStack spacing={2}>
        <Button
          size="sm"
          variant="outline"
          onClick={() => handlePageChange(currentPage - 1)}
          isDisabled={currentPage === 1 || loading}
          border="1px solid #E7E7E7"
        >
          Previous
        </Button>

        {getPageNumbers().map((page) => (
          <Button
            key={page}
            size="sm"
            variant={currentPage === page ? 'solid' : 'outline'}
            bg={currentPage === page ? '#EF6506' : 'white'}
            color={currentPage === page ? 'white' : '#222222'}
            border="1px solid #E7E7E7"
            _hover={{
              bg: currentPage === page ? '#D55A05' : '#F9F9F9',
            }}
            onClick={() => handlePageChange(page)}
            isDisabled={loading}
          >
            {page}
          </Button>
        ))}

        <Button
          size="sm"
          variant="outline"
          onClick={() => handlePageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages || loading}
          border="1px solid #E7E7E7"
        >
          Next
        </Button>
      </HStack>
    </Flex>
  );
};

export default PaginationControls;
